export const deepClone = obj => JSON.parse(JSON.stringify(obj));
